import {
  BarChartIcon,
  ChartColumnIncreasing,
  ClipboardList,
  Globe,
  Home,
  Megaphone,
  PieChart,
  Settings,
  UserCog,
  Users,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { ROUTES } from "@/constants/routes";
import { useModuleStatus } from "@/features/integrations/api/useModuleStatus";
import { useSegmentTourPromo } from "@/features/segments/tour/useSegmentTourPromo";
import { SidebarItem } from "@/types/sidebar/SidebarProps";

const useClientSidebarRoutes = () => {
  const { t } = useTranslation();
  const { clientId } = useParams();
  const { data: appliesStatus } = useModuleStatus("applies", { clientId });
  const showApplies = appliesStatus?.enabled ?? false;
  const { data: webAnalyticsStatus } = useModuleStatus("web-analytics", { clientId });
  const showWebAnalytics = webAnalyticsStatus?.enabled ?? false;
  const { showHomeCard } = useSegmentTourPromo();

  const topRoutes: SidebarItem[] = [
    {
      path: `/${ROUTES.home}`,
      icon: Home,
      label: t("routes.client.home"),
    },
    {
      path: `/${ROUTES.campaigns}`,
      icon: Megaphone,
      label: t("common.campaigns"),
    },
    {
      path: `/${ROUTES.segments}`,
      icon: PieChart,
      label: t("routes.client.segments"),
      beacon: showHomeCard ? t("admin.segments.tour.menuBeacon.description") : undefined,
    },
    {
      path: `/${ROUTES.vacancies}`,
      icon: Users,
      label: t("routes.client.vacancies"),
    },
    ...(showApplies
      ? [
        {
          path: `/${ROUTES.applies}`,
          icon: ClipboardList,
          label: t("common.applies"),
        },
      ]
      : []),
    {
      path: `/${ROUTES.insights}`,
      icon: BarChartIcon,
      label: t("routes.client.insights"),
    },
    {
      path: `/${ROUTES.reporting}`,
      icon: ChartColumnIncreasing,
      label: t("integrations.modules.names.reporting", "Reporting"),
    },
    ...(showWebAnalytics
      ? [
        {
          path: `/${ROUTES.webAnalytics}`,
          icon: Globe,
          label: t("webAnalytics.title"),
        },
      ]
      : []),
    {
      path: `/${ROUTES.users}`,
      icon: UserCog,
      label: t("routes.client.users"),
    },
  ];

  const bottomRoutes: SidebarItem[] = [
    ...(clientId
      ? [
        {
          path: `/${ROUTES.clients}/${clientId}/${ROUTES.edit}`,
          icon: Settings,
          label: t("common.clientSettings"),
        },
      ]
      : []),
  ];

  return { topRoutes, bottomRoutes };
};

export { useClientSidebarRoutes };
